import styled from 'styled-components'

export interface ITabContentFooterStyledProps {
  isFloating?: boolean
  isSticky?: boolean
}

export const TabContentFooterStyled = styled.div<ITabContentFooterStyledProps>`
  position: relative;
  color: ${(props) => props.theme.colors.text.primary};

  border-bottom-left-radius: ${(props) =>
    props.theme.box.borderRadius(props.theme.typography.htmlFontSize || 16)};
  border-bottom-right-radius: ${(props) =>
    props.theme.box.borderRadius(props.theme.typography.htmlFontSize || 16)};

  margin-top: ${(props) => props.theme.space.large};
  margin-right: ${(props) => `-${props.theme.space.large}`};
  margin-bottom: ${(props) => `-${props.theme.space.large}`};
  margin-left: ${(props) => `-${props.theme.space.large}`};
  padding: ${(props) => props.theme.space.large};

  ${({ isSticky, isFloating, theme }) => {
    if (isSticky) {
      return `
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${theme.colors.content.contentBackground};
        ${isFloating ? `border-top: 1px solid ${theme.colors.content.border};` : ''}
        ${isFloating ? `padding-top: ${theme.space.large};` : ''}
        ${isFloating ? `padding-bottom: ${theme.space.large};` : ''}
      `
    }
  }}
`
